<div class="flex-row">
    <mat-card id="financial" class="card">
        <a id="financial_link"></a>
        <input #collapse_financial type="checkbox" [hidden]="true">
        <mat-card-header class="card-header">
            <mat-card-title>
                Financial
            </mat-card-title>
            <div style="flex-basis: 20%; justify-content: flex-end; display: flex;">
                <button mat-button class="service-charge-button" (click)="addRate()">Add Rate</button>
                <button
                    mat-button
                    (click)="isFinancialGridEditToggled ? disableFinancialEditing() : enableFinancialEditing()"
                    class="service-charge-button">
                    <ng-container *ngIf="isFinancialGridEditToggled; else disableIcon">
                        <i class="fa-solid fa-floppy-disk"></i> SAVE CHANGES
                    </ng-container>
                    <ng-template #disableIcon>
                        <i class="fa-regular fa-floppy-disk"></i> EDIT
                    </ng-template>
                </button>
                <button
                    mat-button (click)="openFinancialModal()" class="service-charge-button">ADD
                    SERVICE CHARGE
                </button>
                <button 
                    mat-button (click)="openRemoveServiceModal()" class="service-charge-button">REMOVE
                    SERVICE CHARGE
                </button>
            </div>
        </mat-card-header>
        <mat-card-content style="max-height:fit-content; margin-left: 1em; margin-right: 1em" *ngIf="!collapse_financial.checked">
            <div *ngIf="!showFinancialInfo" class="loading-spinner">
                <mat-spinner></mat-spinner>
            </div>

            <ng-container *ngIf="showFinancialInfo">
                <ag-grid-angular style="width: 100%" class="ag-theme-alpine" [columnDefs]="financialColumnDefs"
                    [defaultColDef]="defaultColDef" [animateRows]="true" [rowData]="financialRowData"
                    domLayout="autoHeight" (cellEditingStopped)="onCellEditingStopped($event)">
                </ag-grid-angular>
            </ng-container>
        </mat-card-content>
    </mat-card>
</div>